// extracted by mini-css-extract-plugin
export default {"container":"qN-z","topReviewHeading":"rN-z","criticalReview":"sN-z","favorableReview":"tN-z","vsSeparator":"uN-z"};